// Coins keep up to 4 decimals in the database (never rounded there). On
// screen: at most 2 decimals, trailing zeros dropped — 7, 0.7, 7.77.
export const num = (v, max = 2) => {
  const n = Number(v);
  if (v === null || v === undefined || v === "" || Number.isNaN(n)) return "0";
  return n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: max });
};

// A typed amount: > 0 with at most 4 decimals (what the database keeps).
export const isAmount = (v) => /^\d+(\.\d{1,4})?$/.test(String(v ?? "").trim()) && Number(v) > 0;
